module.exports = __webpack_public_path__ + "static/media/img_6.b2bd3db8.png";